export default defineNuxtRouteMiddleware((to, from) => {
    const {$msal} = useNuxtApp()

    if (['/login', '/'].includes(to.path) === false) {
        localStorage.setItem('sbl.currentRoute', to.path)
    }

    if (!$msal.getActiveAccount() && to.path !== '/login') {
        return navigateTo('/login')
    }
})
